import { IRequestedAddressResponse, IShipmentLocation } from '@cemex-core/cmx-api';
import { IAddress } from '@cemex-core/cmx-api/models/address/address.interface';
import { IPointOfDeliverySalesArea } from '@cemex-core/cmx-api/models/point-of-delivery-sales-areas/point-of-delivery-sales-area';
import { ILocationConfigUnit } from '@ordersnproducts/modules/order-builder/modules/location/models/location-config.interface';
import { PointOfDeliveryActions,
  LOAD_INITIAL_STATE,
  LOAD_ADDRESS,
  REMOVE_SELECTED_POD,
  POINT_OF_DELIVERY_SET,
  LOAD_ADDRESS_SUCCESS,
  LOAD_SALES_AREA_SUCCESS,
  POD_SET_AVAILABILITY,
  TOGGLE_SHOWING_POD_REQUESTS,
  POINT_OF_DELIVERY_CREATED_SUCCESS,
  POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS,
  POINT_OF_DELIVERY_CREATED_FAILURE,
  RESET_NEW_POINT_OF_DELIVERY,
  LOAD,
  LOAD_COMPLETE,
  RESET_SNAPSHOT,
  UPDATE_SNAPSHOT,
} from '../actions/point-of-delivery.actions';
import {

} from '@ordersnproducts/modules/order-builder/modules/location/actions/point-of-delivery-actions/point-of-delivery.actions';

export interface State {
    required: boolean;
    disabled: boolean;
    loaded: boolean;
    visible: boolean;
    loading: boolean;
    pointOfDeliveries: IShipmentLocation[];
    selected: IShipmentLocation;
    snapShot: IShipmentLocation;
    address: IAddress | IRequestedAddressResponse;
    pointOfDeliverySalesArea: IPointOfDeliverySalesArea[];
    showRequestedPointOfDeliveries: boolean;
    createdPointOfDelivery?: any;
    errorPointOfDelivery?: any;
  }

  export const initialState: State = {
    required: false,
    disabled: false,
    visible: false,
    loaded: false,
    loading: false,
    pointOfDeliveries: [],
    selected: null,
    snapShot: null,
    address: null,
    pointOfDeliverySalesArea: [],
    showRequestedPointOfDeliveries: true,
    createdPointOfDelivery: null,
    errorPointOfDelivery: null,
  };

  export function pointOfDeliveryReducer(state = initialState, action: PointOfDeliveryActions): State {
    switch (action.type) {
      case LOAD_INITIAL_STATE: {
        if (action.payload) {
          const podInitialState: ILocationConfigUnit = action.payload;
          return {
            ...state,
            disabled: podInitialState.disabled,
            required: podInitialState.required,
            visible: podInitialState.visible,
          };
        } else {
          return {
            ...initialState,
          };
        }
      }
      case LOAD:
      case LOAD_ADDRESS: {
        return {
          ...state,
          loading: true,
        };
      }
      case LOAD_COMPLETE: {
        const shipmentLocations: IShipmentLocation[] = action.payload.shipmentLocations;
        return {
          ...state,
          loaded: true,
          loading: false,
          pointOfDeliveries: shipmentLocations,
        };
      }

      case REMOVE_SELECTED_POD: {
        return {
          ...state,
          selected: null,
          address: null,
        };
      }

      case POINT_OF_DELIVERY_SET: {
        return {
          ...state,
          selected: action.payload,
          snapShot: state.selected,
        };
      }
      case LOAD_ADDRESS_SUCCESS: {
        return {
          ...state,
          loading: false,
          address: action.payload,
        };
      }
      case LOAD_SALES_AREA_SUCCESS: {
        return {
          ...state,
          pointOfDeliverySalesArea: action.payload,
        };
      }
      case POD_SET_AVAILABILITY: {
        return {
          ...state,
          disabled: action.payload,
        };
      }
      case TOGGLE_SHOWING_POD_REQUESTS: {
        return {
          ...state,
          showRequestedPointOfDeliveries: action.payload,
        };
      }
      case POINT_OF_DELIVERY_CREATED_SUCCESS: {
        return {
          ...state,
          createdPointOfDelivery: action.payload,
          errorPointOfDelivery: null,
        };
      }
      case POINT_OF_DELIVERY_OPPORTUNITIES_CREATE_SUCCESS: {
        return {
          ...state,
          createdPointOfDelivery: action.payload,
          errorPointOfDelivery: null,
        };
      }
      case POINT_OF_DELIVERY_CREATED_FAILURE: {
        return {
          ...state,
          createdPointOfDelivery: null,
          errorPointOfDelivery: action.payload,
        };
      }
      case RESET_NEW_POINT_OF_DELIVERY: {
        return {
          ...state,
          createdPointOfDelivery: null,
          errorPointOfDelivery: null,
        };
      }
      case RESET_SNAPSHOT: {
        return {
          ...state,
          snapShot: null,
        };
      }
      case UPDATE_SNAPSHOT: {
        return {
          ...state,
          snapShot: state.selected,
        };
      }
      default: {
        return state;
      }
    }
  }
